export const DESTINATION_NAV_API_URL = 'headerData/destinationsNav';
export const SEARCH_API_URL = 'search';
export const SEARCH_API_URL_USER = 'users/me/search';
export const EMULATED_SEARCH_API_URL = 'users/predictiveSearchForEmulated';

export const LOCALSTORAGE_DEST_NAV_KEY = 'dest-nav-page';

export const DESTINATION_REACT_APP_BASE_URL = '/destinations/#/searchResults/';

export const ERROR_MESSAGE = 'Apologies - this content has failed to load.';
export const INFO_ICON =
  'https://content-qa.vistana.com/files/live/sites/vistana-digital-content-manager/files/images/react-apps/info.png';

//HANDLING ELECTION SESSION/LOCAL STORAGE KEYS SINCE DESTINATION NAV IS PRESENT IN VISTANA HEADER THROUGHOUT THE WEBSITE
export const ELECTION_PATH_NAME = '/elect-for-club-points';
export const SESSION_PERSIST_KEY = 'persist:vse_election';
export const LOCALSTORAGE_ELECTION_KEY = 'election-data';
export const LOCALSTORAGE_ELECTION_YEARS = 'election-year';
export const SEARCH_ID = 'nav-menu-search';
